import { Link, Stack } from '@pie/amber';

export const Footer = () => {
  return (
    <footer
      className="
        pb-layout-sm md:pb-layout-md
        pt-layout-sm
        px-layout-sm md:px-layout-md
      "
    >
      <div className="max-w-[1232px] m-auto">
        <Stack align="center" direction="row" gap="md" justify="start">
          <Link
            href="https://www.pieinsurance.com/legal/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
            variant="body-xs"
          >
            Terms of Use
          </Link>
          <Link
            href="https://www.pieinsurance.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            variant="body-xs"
          >
            Privacy Policy
          </Link>
          <Link
            href="https://www.pieinsurance.com/legal/cookie-notice"
            target="_blank"
            rel="noopener noreferrer"
            variant="body-xs"
          >
            Cookie Notice
          </Link>
        </Stack>
      </div>
    </footer>
  );
};
